import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { getSession } from 'next-auth/react';
import { closePopup } from '@solidstarters/solid-core-ui/dist/redux/features/popupSlice';
import { useDispatch } from 'react-redux';

const API_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL;

const templateoptions = [
  { label: 'Import Template format', value: 'Import Template format' },
  { label: 'Export Template format', value: 'Export Template format' },
  { label: 'Extension Template format', value: 'Extension Template format' },
];

const validationSchema = Yup.object({
  templateFormatType: Yup.string().required('Template format type is required'),
});


const GenerateTemplateFormat = ({ context }: any) => {
  const dispatch = useDispatch()
  const toast = useRef<Toast>(null);

  const handleGenerateTemplateFormat = async (templateFormatType: string) => {
    try {
      const session: any = await getSession();
      const token = session?.user?.accessToken || '';

      const response = await axios.get(`${API_URL}/api/generate-template-format`, {
        params: { templateFormatType },
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      const disposition = response.headers['content-disposition'];
      const filename = disposition?.split('filename=')[1]?.replace(/"/g, '') || 'report.xlsx';

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.current?.show({
        severity: 'success',
        summary: 'Template Downloaded',
        detail: filename,
        life: 3000,
      });
    } catch (error) {
      console.error('Report generation error:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to generate report',
        life: 3000,
      });
    }
  };

  return (
    <div className="mt-10 px-4 bg-white rounded-xl shadow-lg border border-gray-200">
      <Toast ref={toast} />
      <Formik
        initialValues={{ templateFormatType: '' }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          await handleGenerateTemplateFormat(
            values.templateFormatType,
          );
          setSubmitting(false);
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => {
          return (
            <Form className="space-y-2 min-w-[400px]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-end mt-5 ">
               
              <h4 className="text-center w-full text-blue-900">Generate Template Formate</h4>
                <div className='w-full'>
                  <label htmlFor="templateFormatType" className="block text-sm font-semibold text-gray-700 mb-2">
                    Select Template Format Type
                  </label>
                  <Dropdown
                    id="templateFormatType"
                    options={templateoptions}
                    value={values.templateFormatType}
                    onChange={(e) => setFieldValue('templateFormatType', e.value)}
                    placeholder="Select report type"
                    className="w-full p-inputtext-sm"
                  />
                  <ErrorMessage name="templateFormatType" component="div" className="text-red-500 text-sm mt-1" />
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-6 py-3">
                <Button
                  label="Cancel"
                  className="p-button-secondary"
                  type="button"
                  onClick={() => dispatch(closePopup())}
                />
                <Button
                  label="Generate"
                  icon="pi pi-check"
                  type="submit"
                  loading={isSubmitting}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default GenerateTemplateFormat;
